module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/access-d890752bcc8918cb8b3637332d594aff.svg";